/**
 * @internal
 */
export const isFunction = (object) => typeof object === "function";
/**
 * @internal
 */
export const isString = (object) => typeof object === "string";
/**
 * @internal
 */
export const noop = () => void 0;
